import Index from './EngagementsIndex';
import New from './NewEngagement';
import Show from './ShowEngagement';

export default { Index, New, Show };
